export default __webpack_public_path__ + "static/media/party-jake.99cd92c5.jpg";